export default {
    getServer: (state) => (data) => {
        return state.server
    }
}